import { initialState } from '@/reducers/listView'

const UPDATE = 'focusFans/UPDATE'

const focusFansActions = {
  UPDATE
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case focusFansActions.UPDATE:
      return {
        ...state,
        ...payload
      }
    default:
      return state
  }
}
